/**
 * tableFilter.jsx
 *
 * @Author: apple
 * @Date: 2018/1/11 11:37
 */

import React from 'react';
import classNames from 'classnames';
import Checkbox, { CheckboxGroup } from '../checkbox';
import Radio, { RadioGroup } from '../radio';
import ToolTip from '../tooltip';
import FilterList from '../icons/internals/FilterList';
import Button from '../button';

/**
 * @ignore
 * */
class TableFilter extends React.Component {
  static propTypes = {};

  static defaultProps = {};

  constructor(props, context) {
    super(props, context);
    this.state = {
      initFilters: props.filterMultiple ? [] : '',
      tableFilterState: false,
      type: '',
    };
  }

  handleFilter = type => {
    const { filterMethod, filters, filterMultiple } = this.props;
    const { initFilters } = this.state;
    switch (type) {
      case 'sure':
        filterMultiple
          ? filterMethod(
              filters.filter(item => {
                let equal = false;
                initFilters.forEach(id => {
                  if (item.value === id) {
                    equal = true;
                  }
                });
                return equal;
              }),
            )
          : filterMethod(filters.filter(item => initFilters === item.value));
        break;
      case 'reset':
        this.setState(
          {
            initFilters: filterMultiple ? [] : '',
          },
          () => filterMethod([]),
        );
        break;
      default:
    }
  };

  handleSelect = (event, checkedValue) => {
    this.setState({
      initFilters: checkedValue,
    });
  };

  handleTableFilterOpen = () => {
    this.setState({
      tableFilterState: true,
    });
  };

  handleTableFilterClose = type => {
    this.setState({
      tableFilterState: false,
      type,
    });
  };

  handleCloseTooltip = () => {
    const { type } = this.state;
    if (type) this.handleFilter(type);
  };

  render() {
    const { prefixCls, filters, filterMultiple, id } = this.props;
    const { initFilters, tableFilterState } = this.state;
    let onFiltered = false;
    if (filterMultiple) {
      onFiltered = !!initFilters.length;
    } else {
      onFiltered = !!initFilters;
    }
    return (
      <ToolTip
        content={
          <FilterList
            data-filter={id}
            className={classNames(`${prefixCls}-icon`, {
              [`${prefixCls}-icon-filtered`]: onFiltered,
            })}/>
        }
        trigger="click"
        isOpen={tableFilterState}
        onOpen={this.handleTableFilterOpen}
        onClose={this.handleCloseTooltip}
        position="bottomLeft">
        <div className={`${prefixCls}-filter`}>
          {filterMultiple ? (
            <CheckboxGroup
              value={initFilters}
              onChange={(event, value) => this.handleSelect(event, value)}
              className={`${prefixCls}-filter-body`}>
              {filters.map(item => {
                const { label, value } = item;
                return <Checkbox key={value} label={label} value={value} />;
              })}
            </CheckboxGroup>
          ) : (
            <RadioGroup
              value={initFilters}
              onChange={(event, value) => this.handleSelect(event, value)}
              className={`${prefixCls}-filter-body`}>
              {filters.map(item => {
                const { label, value } = item;
                return <Radio key={value} label={label} value={value} />;
              })}
            </RadioGroup>
          )}
          <div className={`${prefixCls}-filter-footer`}>
            <Button size="small" hollow onClick={() => this.handleTableFilterClose('sure')}>
              确定
            </Button>
            <Button size="small" hollow onClick={() => this.handleTableFilterClose('reset')}>
              重置
            </Button>
          </div>
        </div>
      </ToolTip>
    );
  }
}

export default TableFilter;



// WEBPACK FOOTER //
// ./src/table/TableFilter.jsx